/* @flow */

import {
    NIVEL_URGENTE,
    NIVEL_NORMAL,
    NIVEL_ATENCAO,
} from './constants';

const getNivelNotificaoPorMinutos = (diferenca: number) => {
    const storage = JSON.parse(localStorage.getItem('preact-app-state'));
    const isPedidosPendentes = JSON.parse(localStorage.getItem('pedidos-pendentes'));
    const { empresa } = storage.empresa;

    if (diferenca >= empresa.maximoEntrega) {
        return NIVEL_URGENTE;
    }

    if (diferenca >= empresa.minimoEntrega || (isPedidosPendentes && empresa.somContinuo === '1')) {
        return NIVEL_ATENCAO;
    }

    return NIVEL_NORMAL;
};

const getNivelNotificacaoPorData = (a: number, b: number) => (
    getNivelNotificaoPorMinutos((a - b) / 1000 / 60)
);

export default getNivelNotificacaoPorData;
